import { LogErrors } from './../../LogErrors'

import { DoubleAttempt } from './../Helpers/DoubleAttempt'


const GetLearningInstrumentsInstructors = async (token, navigationSession) => {
    try {
        const dataToSend = {
            courseId: navigationSession.course.id,
            itemId: navigationSession.instrument.id
        }
        
        const parameters = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': token
            },
            body: JSON.stringify(dataToSend)
        }

        const url = process.env.REACT_APP_API_URL + "/api/V2/Api/GetLearningInstrumentsInstructors"

        const response = await DoubleAttempt(url, parameters)

        if (response.success) {
            return { success: true, data: response.data }
        } else {
            return { success: false, message: response.message }
        }

        // const response = await fetch(process.env.REACT_APP_API_URL + "/api/V2/Api/GetLearningInstrumentsInstructors", {
        //     method: 'POST',
        //     headers: {
        //         'Content-Type': 'application/json',
        //         'Authorization': token
        //     },
        //     body: JSON.stringify(dataToSend)
        // })
        
        // if (!response.ok) {
        //     // Manejar errores HTTP
        //     const errorData = await response.json()
        //     //return { success: false, message: errorData.message || 'Error de autenticación' }
        //     return { success: false, message: errorData.message } //errorCode
        // }
        
        // const data = await response.json()
        
        // // Retornar la respuesta exitosa
        // return { success: true, data: data }
    } catch (error) {
        await LogErrors('GetLearningInstrumentsInstructors - DL Instruments Instructors', error)
        return { success: false, message: '' }
    }
}

const GetActivityInstructors = async (token, navigationSession) => {
    try {
        const dataToSend = {
            courseId: navigationSession.course.id,
            itemId: navigationSession.instrument.id
        }

        const parameters = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': token
            },
            body: JSON.stringify(dataToSend)
        }
        
        const url = process.env.REACT_APP_API_URL + "/api/V2/Api/GetActivityInstructors"

        const response = await DoubleAttempt(url, parameters)

        if (response.success) {
            return { success: true, data: response.data }
        } else {
            return { success: false, message: response.message }
        }

        // const response = await fetch(process.env.REACT_APP_API_URL + "/api/V2/Api/GetActivityInstructors", {
        //     method: 'POST',
        //     headers: {
        //         'Content-Type': 'application/json',
        //         'Authorization': token
        //     },
        //     body: JSON.stringify(dataToSend)
        // })
        
        // if (!response.ok) {
        //     // Manejar errores HTTP
        //     const errorData = await response.json()
        //     //return { success: false, message: errorData.message || 'Error de autenticación' }
        //     return { success: false, message: errorData.message } //errorCode
        // }
        
        // const data = await response.json()
        
        // // Retornar la respuesta exitosa
        // return { success: true, data: data }
    } catch (error) {
        await LogErrors('GetActivityInstructors - DL Instruments Instructors', error)
        return { success: false, message: '' }
    }
}

export { GetLearningInstrumentsInstructors, GetActivityInstructors };